window.Reverb = window.Reverb || {};

Reverb.BlockSellerAction = (function () {
  function bindSellerBlockActions() {
    $(document).on('click', 'input[data-sellerblock=true],a[data-sellerblock=true],button[data-sellerblock=true]', function (e) {
      e.preventDefault();
      e.stopPropagation();
      showSellerBlockMessage($(this));
    });

    $(document).on('submit', 'form[data-sellerblock=true]', function (e) {
      e.preventDefault();
      e.stopPropagation();
      showSellerBlockMessage($(this));
    });
  }

  function showSellerBlockMessage(clicked) {
    const message = $(clicked).data('sellerblock-message');
    showMessage(message);
  }

  function showMessage(message) {
    $.fancybox($('<h3>', {
      text: message,
      class: 'seller-blocked-message',
    }), {});
  }

  return {
    bindSellerBlockActions,
    showMessage,
  };
}());

$(Reverb.BlockSellerAction.bindSellerBlockActions);



// WEBPACK FOOTER //
// ./src/components/legacy/block_seller_action.js